// prutl-frontend-npm6node14/src/pages/AwardManagement.jsx

import React from 'react';
import AwardList from '../components/awardManagement/AwardList.jsx';

const AwardManagement = () => {
  return (
    <div className="awardManagementContainer">
      <h1>Award Management</h1>
      <AwardList />
    </div>
  );
};

export default AwardManagement;
